import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import statsFactory from './sports/factory';
import {cssClassMap} from 'rendering-commons/SportCssMap';

class MatchStats extends React.Component {
    static propTypes = {
        section: PropTypes.string.isRequired,
        matchId: PropTypes.number.isRequired,
        gridLocalization: PropTypes.object.isRequired,
        scores: PropTypes.object,
        remark: PropTypes.string,
        period: PropTypes.object,
        sportId: PropTypes.number
    };

    shouldComponentUpdate(nextProps) {
        return this.props.scores !== nextProps.scores ||
            this.props.period !== nextProps.period ||
            this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId ||
            this.props.remark !== nextProps.remark;
    }

    render() {
        const {section, matchId, period, scores, remark, sportId, gridLocalization} = this.props;

        if (!sportId || !period) {
            return false;
        }

        const Renderer = statsFactory(sportId);

        if (!remark && !Renderer) {
            return false;
        }

        let rendererProps;

        const iconClass = 'sport-icon svg-' + cssClassMap[sportId];

        const periodId = period.get('id');

        const periodName = gridLocalization.getPeriodName(sportId, periodId);
        const timeoutText = gridLocalization.getTimeoutText();
        const foulsText = gridLocalization.getFoulsText();

        const periodJs = this.props.period.set('name', periodName).toJS();

        rendererProps = {section, matchId, sportId, scores, periodJs, timeoutText, foulsText, iconClass, remark};

        return <Renderer {...rendererProps}/>
    }
}

function select(state, props) {
    const {section, matchId} = props;

    const match = state.application.getIn([section, 'matches', matchId]);

    let scores, remark, period, sportId;

    if (match) {
        scores = match.get('scores');
        remark = match.get('remark');
        period = match.get('period');
        sportId = match.get('realSportId');
    }

    return {
        section,
        matchId,
        scores,
        remark,
        period,
        sportId
    };
}

export default connect(select)(MatchStats);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/MatchStats.jsx